import { CategoryModel, LinkModel } from '@/types';
import AtAGlanceSummary from './AtAGlanceSummary';
import AtAGlanceDrivers from './AtAGlanceDrivers';
import AtAGlanceMap from './AtAGlanceMap';
import AtAGlanceInnovationPlatforms from './AtAGlanceInnovationPlatforms';
import AtAGlanceTrendDuration from './AtAGlanceTrendDuration';

export type AtAGlanceModel = {
  innovationPlatforms: CategoryModel[];
  topics: CategoryModel[];
  macroDrivers: CategoryModel[];
  trendDuration: string;
  trendStage: string;
  summary?: {
    blocks: [
      {
        anchor: LinkModel;
        heading: string;
        text: string;
      },
    ];
  };
  mapModule?: {
    regionMap: string;
    countryCodes: string;
    regions: {
      countryCodes: string;
      description: string;
      regionCategoryCodeName: string;
      regionId: number;
      regionName: string;
    }[];
  };
  backgroundColour?: string;
};

const AtAGlance = ({
  innovationPlatforms,
  macroDrivers,
  trendDuration,
  summary,
  mapModule,
  backgroundColour,
}: AtAGlanceModel) => {
  return (
    <div className="flex flex-col xl:flex-row">
      <div className="flex w-full flex-col pr-2 xl:w-1/2">
        <AtAGlanceSummary summary={summary} />
      </div>
      <div className="flex w-full flex-col border-l border-black/20 pb-16 xl:w-1/2 print:border-l-0 [&_>div]:border-b [&_>div]:border-black/20 [&_>div]:pb-6 [&_>div]:last:border-0 [&_>div]:last:pb-0">
        {macroDrivers && <AtAGlanceDrivers macroDrivers={macroDrivers} />}
        {mapModule && <AtAGlanceMap mapModule={mapModule} backgroundColour={backgroundColour} />}
        {innovationPlatforms && <AtAGlanceInnovationPlatforms innovationPlatforms={innovationPlatforms} />}
        <AtAGlanceTrendDuration trendDuration={trendDuration} backgroundColour={backgroundColour} />
      </div>
    </div>
  );
};

export default AtAGlance;
